export enum MesEtablissementSearcholonneEnum {
  SIRET = 'siret',
  CODEPOSTAL = 'codePostal',
  RAISONSOCIALE = 'raisonSociale',
}
